import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { OnInit, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main/view.scss */
:host {
  display: block;
}`],
})
export class PageMainComponent implements OnInit {
    public is_add_project: boolean = false;
    public isDashboardReady: boolean = false;
    public isAdminDashboard: boolean = false;
    public isOperationDashboard: boolean = false;
    public isTechDashboard: boolean = false;
    public isFieldDashboard: boolean = false;
    public isFieldStaffDashboard: boolean = false;
    public user: any = null;

    /** 진단 유형별 프로젝트 그룹 */
    public grouped: any = { regular: [], fine: [], diagnosis: [], other: [] };

    /** 통계 데이터 */
    public stats: any = { total: 0, regular: 0, fine: 0, diagnosis: 0 };

    /** 선택된 프로젝트 목록 */
    public selectedProjects: any[] = [];

    /** 관리자 전용 전체 운영 KPI */
    public adminStats: any = {
        total_projects: 0,
        scheduled: 0,
        in_progress: 0,
        completed: 0,
        building: 0,
        civil: 0,
        other: 0,
        total_contract_amount: 0,
        total_users: 0,
        admin_users: 0,
        manager_users: 0,
        normal_users: 0,
        total_checklists: 0,
        published_checklists: 0,
        draft_checklists: 0,
        template_checklists: 0,
        total_responses: 0,
        draft_responses: 0,
        submitted_responses: 0,
        reviewed_responses: 0,
        total_facilities: 0,
        total_drawings: 0,
        total_documents: 0
    };
    public adminActionStats: any = {
        total: 0,
        unassigned_distribution: 0,
        unassigned_technicians: 0,
        review_pending: 0,
        risk_responses: 0
    };
    public adminActions: any = {
        unassigned_distribution: [],
        unassigned_technicians: [],
        review_pending: [],
        risk_responses: []
    };
    public adminWorkflow: any[] = [];
    public adminDepartments: any[] = [];

    /** 운영본부 전용 용역 현황 */
    public operationProjects: any[] = [];
    public operationStats: any = {
        total: 0,
        building: 0,
        civil: 0,
        other: 0,
        in_progress: 0,
        scheduled: 0,
        completed: 0
    };
    public operationStatusFilter: string = 'all';
    public operationPage: number = 1;
    public operationPageSize: number = 5;

    /** 현장본부장 전용 용역 현황 */
    public fieldProjects: any[] = [];
    public fieldStats: any = {
        total: 0,
        pending_distribution: 0,
        scheduled: 0,
        in_progress: 0,
        completed: 0
    };
    public fieldStatusFilter: string = 'all';
    public fieldPage: number = 1;
    public fieldPageSize: number = 5;
    public isTechnicianModalOpen: boolean = false;
    public assignmentProject: any = null;
    public technicianUsers: any[] = [];
    public selectedTechnicianIds: string[] = [];
    public assignmentLoading: boolean = false;
    public assignmentSaving: boolean = false;

    /** 기술본부 전용 분배 현황 */
    public techProjects: any[] = [];
    public techStats: any = {
        total: 0,
        pending: 0,
        building: 0,
        civil: 0,
        other: 0,
        in_progress: 0,
        scheduled: 0,
        completed: 0
    };
    public techFilter: string = 'all';
    public techPage: number = 1;
    public techPageSize: number = 6;
    public techAssigningProjectId: string = '';
    public techTargets: any[] = [
        { key: '건축', label: '건축', icon: 'fa-solid fa-building' },
        { key: '토목', label: '토목', icon: 'fa-solid fa-road' },
        { key: '기타', label: '기타', icon: 'fa-solid fa-layer-group' }
    ];

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() {
        await this.service.init(this);
        await this.loadDashboard();
        this.isDashboardReady = true;
        await this.service.loading.hide();
        this.ref.detectChanges();
    }

    public async loadDashboard() {
        try {
            const { code, data } = await wiz.call('data', {});
            if (code === 200) {
                this.grouped = data.grouped || this.grouped;
                this.stats = data.stats || this.stats;
                this.selectedProjects = data.selectedProjects || [];
                this.isAdminDashboard = !!data.is_admin_dashboard;
                this.isOperationDashboard = !!data.is_operation_dashboard;
                this.isTechDashboard = !!data.is_tech_dashboard;
                this.isFieldDashboard = !!data.is_field_dashboard;
                this.isFieldStaffDashboard = !!data.is_field_staff_dashboard;
                this.user = data.user || null;
                this.adminStats = data.adminStats || this.adminStats;
                this.adminActionStats = data.adminActionStats || this.adminActionStats;
                this.adminActions = data.adminActions || this.adminActions;
                this.adminWorkflow = data.adminWorkflow || [];
                this.adminDepartments = data.adminDepartments || [];
                this.operationProjects = data.operationProjects || [];
                this.operationStats = data.operationStats || this.operationStats;
                this.techProjects = data.techProjects || [];
                this.techStats = data.techStats || this.techStats;
                this.fieldProjects = data.fieldProjects || [];
                this.fieldStats = data.fieldStats || this.fieldStats;
                this.normalizeOperationPage();
                this.normalizeTechPage();
                this.normalizeFieldPage();
            }
        } catch (e) {
            console.error('Dashboard data load error:', e);
        }
    }

    public get filteredOperationProjects(): any[] {
        if (this.operationStatusFilter === 'all') return this.operationProjects;
        return this.operationProjects.filter((project: any) => project.dashboard_status === this.operationStatusFilter);
    }

    public get pagedOperationProjects(): any[] {
        const start = (this.operationPage - 1) * this.operationPageSize;
        return this.filteredOperationProjects.slice(start, start + this.operationPageSize);
    }

    public get operationTotalPages(): number {
        return Math.max(1, Math.ceil(this.filteredOperationProjects.length / this.operationPageSize));
    }

    public get operationPages(): number[] {
        return Array.from({ length: this.operationTotalPages }, (_, index) => index + 1);
    }

    public get operationPageStart(): number {
        if (this.filteredOperationProjects.length === 0) return 0;
        return (this.operationPage - 1) * this.operationPageSize + 1;
    }

    public get operationPageEnd(): number {
        return Math.min(this.operationPage * this.operationPageSize, this.filteredOperationProjects.length);
    }

    public get filteredFieldProjects(): any[] {
        if (this.fieldStatusFilter === 'all') return this.fieldProjects;
        if (this.fieldStatusFilter === 'pending_distribution') {
            return this.fieldProjects.filter((project: any) => project.distribution_status === 'pending');
        }
        return this.fieldProjects.filter((project: any) => project.dashboard_status === this.fieldStatusFilter);
    }

    public get pagedFieldProjects(): any[] {
        const start = (this.fieldPage - 1) * this.fieldPageSize;
        return this.filteredFieldProjects.slice(start, start + this.fieldPageSize);
    }

    public get fieldTotalPages(): number {
        return Math.max(1, Math.ceil(this.filteredFieldProjects.length / this.fieldPageSize));
    }

    public get fieldPages(): number[] {
        return Array.from({ length: this.fieldTotalPages }, (_, index) => index + 1);
    }

    public get fieldPageStart(): number {
        if (this.filteredFieldProjects.length === 0) return 0;
        return (this.fieldPage - 1) * this.fieldPageSize + 1;
    }

    public get fieldPageEnd(): number {
        return Math.min(this.fieldPage * this.fieldPageSize, this.filteredFieldProjects.length);
    }

    public get fieldDashboardTitle(): string {
        if (this.isFieldStaffDashboard) return '내 프로젝트';
        return `${this.getCategoryLabel(this.user?.department)} 현장본부 대시보드`;
    }

    public get fieldDashboardSummaryLabel(): string {
        return this.isFieldStaffDashboard ? '할당 프로젝트' : '부서 프로젝트';
    }

    public get fieldDashboardListTitle(): string {
        return this.isFieldStaffDashboard ? '할당 프로젝트 목록' : '프로젝트 목록';
    }

    public get fieldEmptyMessage(): string {
        return this.isFieldStaffDashboard ? '할당된 프로젝트가 없습니다' : '해당 상태의 프로젝트가 없습니다';
    }

    public get selectedTechnicianCount(): number {
        return this.selectedTechnicianIds.length;
    }

    public get filteredTechProjects(): any[] {
        if (this.techFilter === 'all') return this.techProjects;
        if (this.techFilter === 'pending') {
            return this.techProjects.filter((project: any) => project.distribution_status === 'pending');
        }
        return this.techProjects.filter((project: any) => this.isTechTargetSelected(project, this.techFilter));
    }

    public get pagedTechProjects(): any[] {
        const start = (this.techPage - 1) * this.techPageSize;
        return this.filteredTechProjects.slice(start, start + this.techPageSize);
    }

    public get techTotalPages(): number {
        return Math.max(1, Math.ceil(this.filteredTechProjects.length / this.techPageSize));
    }

    public get techPages(): number[] {
        return Array.from({ length: this.techTotalPages }, (_, index) => index + 1);
    }

    public get techPageStart(): number {
        if (this.filteredTechProjects.length === 0) return 0;
        return (this.techPage - 1) * this.techPageSize + 1;
    }

    public get techPageEnd(): number {
        return Math.min(this.techPage * this.techPageSize, this.filteredTechProjects.length);
    }

    public setOperationStatusFilter(status: string) {
        this.operationStatusFilter = status;
        this.operationPage = 1;
        this.ref.detectChanges();
    }

    public setOperationPage(page: number) {
        this.operationPage = Math.min(Math.max(1, page), this.operationTotalPages);
        this.ref.detectChanges();
    }

    private normalizeOperationPage() {
        this.operationPage = Math.min(Math.max(1, this.operationPage), this.operationTotalPages);
    }

    public setFieldStatusFilter(status: string) {
        this.fieldStatusFilter = status;
        this.fieldPage = 1;
        this.ref.detectChanges();
    }

    public setFieldPage(page: number) {
        this.fieldPage = Math.min(Math.max(1, page), this.fieldTotalPages);
        this.ref.detectChanges();
    }

    private normalizeFieldPage() {
        this.fieldPage = Math.min(Math.max(1, this.fieldPage), this.fieldTotalPages);
    }

    public setTechFilter(filter: string) {
        this.techFilter = filter;
        this.techPage = 1;
        this.ref.detectChanges();
    }

    public setTechPage(page: number) {
        this.techPage = Math.min(Math.max(1, page), this.techTotalPages);
        this.ref.detectChanges();
    }

    private normalizeTechPage() {
        this.techPage = Math.min(Math.max(1, this.techPage), this.techTotalPages);
    }

    public getOperationStatusCount(status: string): number {
        if (status === 'all') return this.operationProjects.length;
        return this.operationProjects.filter((project: any) => project.dashboard_status === status).length;
    }

    public getFieldStatusCount(status: string): number {
        if (status === 'all') return this.fieldProjects.length;
        if (status === 'pending_distribution') {
            return this.fieldProjects.filter((project: any) => project.distribution_status === 'pending').length;
        }
        return this.fieldProjects.filter((project: any) => project.dashboard_status === status).length;
    }

    public getStatusFilterClass(status: string): string {
        const base = 'px-4 py-2 rounded-2xl text-sm font-semibold border transition-all duration-200 flex items-center gap-2';
        if (this.operationStatusFilter === status) {
            return `${base} bg-slate-900 border-slate-900 text-white shadow-sm`;
        }
        return `${base} bg-white border-gray-200 text-slate-500 hover:border-emerald-300 hover:text-emerald-600`;
    }

    public getFieldStatusFilterClass(status: string): string {
        const base = 'px-4 py-2 rounded-xl text-sm font-semibold border transition-all duration-200 flex items-center gap-2';
        if (this.fieldStatusFilter === status) {
            return `${base} bg-slate-900 border-slate-900 text-white shadow-sm`;
        }
        return `${base} bg-white border-gray-200 text-slate-500 hover:border-blue-300 hover:text-blue-600`;
    }

    public getTechFilterCount(filter: string): number {
        if (filter === 'all') return this.techStats.total || 0;
        if (filter === 'pending') return this.techStats.pending || 0;
        if (filter === '건축') return this.techStats.building || 0;
        if (filter === '토목') return this.techStats.civil || 0;
        return this.techStats.other || 0;
    }

    public getTechFilterClass(filter: string): string {
        const base = 'px-4 py-2 rounded-2xl text-sm font-semibold border transition-all duration-200 flex items-center gap-2';
        if (this.techFilter === filter) {
            return `${base} bg-slate-900 border-slate-900 text-white shadow-sm`;
        }
        return `${base} bg-white border-gray-200 text-slate-500 hover:border-sky-300 hover:text-sky-600`;
    }

    public getTechTargetBadgeClass(project: any): string {
        if (project?.distribution_status === 'pending') return 'bg-rose-50 text-rose-600';
        const targets = this.getProjectTargets(project);
        if (targets.length > 1) return 'bg-sky-50 text-sky-600';
        if (targets.includes('건축')) return 'bg-blue-50 text-blue-600';
        if (targets.includes('토목')) return 'bg-orange-50 text-orange-600';
        return 'bg-teal-50 text-teal-600';
    }

    public getTechAssignButtonClass(project: any, target: string): string {
        const base = 'px-3 py-2 rounded-xl text-xs font-semibold border transition-all duration-200 flex items-center justify-center gap-1';
        const active = this.isTechTargetSelected(project, target);
        if (active && target === '건축') return `${base} bg-blue-600 border-blue-600 text-white shadow-sm`;
        if (active && target === '토목') return `${base} bg-orange-500 border-orange-500 text-white shadow-sm`;
        if (active) return `${base} bg-teal-600 border-teal-600 text-white shadow-sm`;
        return `${base} bg-white border-gray-200 text-slate-500 hover:border-sky-300 hover:text-sky-600 disabled:opacity-40`;
    }

    private getProjectTargets(project: any): string[] {
        const allowedTargets = this.techTargets.map((target: any) => target.key);
        const rawTargets = Array.isArray(project?.target_departments)
            ? project.target_departments
            : String(project?.target_department || project?.category || '').split(',');
        const normalized = rawTargets
            .map((target: any) => String(target || '').trim())
            .filter((target: string) => allowedTargets.includes(target));
        return allowedTargets.filter((target: string) => normalized.includes(target));
    }

    public isTechTargetSelected(project: any, target: string): boolean {
        return this.getProjectTargets(project).includes(target);
    }

    public async addProject() {
        if (!this.isOperationDashboard) return;
        this.is_add_project = true;
        this.ref.detectChanges();
    }

    public async onModalClose(success: boolean) {
        this.is_add_project = false;
        if (success) {
            await this.loadDashboard();
        }
        this.ref.detectChanges();
    }

    public updateSelectedProjects(newList: any[]) {
        this.selectedProjects = newList;
        this.ref.detectChanges();
    }

    public async onFieldProjectClick(project: any) {
        if (!project?.id) return;
        if (!this.isFieldDashboard) {
            this.viewProject(project.id);
            return;
        }
        if (project.can_assign_technicians === false || project.distribution_status === 'pending') {
            this.viewProject(project.id);
            return;
        }
        await this.openTechnicianModal(project);
    }

    public async openTechnicianModal(project: any) {
        this.assignmentProject = project;
        this.technicianUsers = [];
        this.selectedTechnicianIds = [];
        this.assignmentLoading = true;
        this.assignmentSaving = false;
        this.isTechnicianModalOpen = true;
        this.ref.detectChanges();

        try {
            const { code, data } = await wiz.call('field_technicians', { project_id: project.id });
            if (code === 200) {
                this.assignmentProject = data.project || project;
                this.technicianUsers = data.users || [];
                this.selectedTechnicianIds = this.technicianUsers
                    .filter((user: any) => !!user.selected)
                    .map((user: any) => user.id);
                return;
            }
            await this.service.alert.show({
                title: '알림',
                message: data || '기술자 목록을 불러올 수 없습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
            this.closeTechnicianModal();
        } catch (e: any) {
            await this.service.alert.show({
                title: '알림',
                message: e?.message || '기술자 목록 조회 중 오류가 발생했습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
            this.closeTechnicianModal();
        } finally {
            this.assignmentLoading = false;
            this.ref.detectChanges();
        }
    }

    public closeTechnicianModal() {
        this.isTechnicianModalOpen = false;
        this.assignmentProject = null;
        this.technicianUsers = [];
        this.selectedTechnicianIds = [];
        this.assignmentLoading = false;
        this.assignmentSaving = false;
        this.ref.detectChanges();
    }

    public isTechnicianSelected(user: any): boolean {
        return this.selectedTechnicianIds.includes(user?.id);
    }

    public toggleTechnician(user: any) {
        if (!user?.id || this.assignmentSaving) return;
        const index = this.selectedTechnicianIds.indexOf(user.id);
        if (index >= 0) {
            this.selectedTechnicianIds.splice(index, 1);
        } else {
            this.selectedTechnicianIds.push(user.id);
        }
        this.ref.detectChanges();
    }

    public async saveTechnicianAssignment() {
        if (!this.assignmentProject?.id || this.assignmentSaving) return;
        this.assignmentSaving = true;
        this.ref.detectChanges();

        try {
            const { code, data } = await wiz.call('assign_technicians', {
                project_id: this.assignmentProject.id,
                technician_ids: this.selectedTechnicianIds.join(',')
            });
            if (code !== 200) {
                await this.service.alert.show({
                    title: '알림',
                    message: data || '기술자 지정을 저장할 수 없습니다.',
                    status: 'error',
                    action: '확인',
                    cancel: false
                });
                return;
            }
            await this.loadDashboard();
            this.closeTechnicianModal();
            await this.service.alert.show({
                title: '저장 완료',
                message: `${data.count || 0}명의 기술자를 지정했습니다.`,
                status: 'success',
                action: '확인',
                cancel: false
            });
        } catch (e: any) {
            await this.service.alert.show({
                title: '알림',
                message: e?.message || '기술자 지정 중 오류가 발생했습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
        } finally {
            this.assignmentSaving = false;
            this.ref.detectChanges();
        }
    }

    public async assignTechProject(project: any, target: string, event?: Event) {
        if (event) event.stopPropagation();
        if (!project?.id || this.techAssigningProjectId) return;

        this.techAssigningProjectId = project.id;
        const currentTargets = this.getProjectTargets(project);
        const nextTargets = currentTargets.includes(target)
            ? currentTargets.filter((item: string) => item !== target)
            : [...currentTargets, target];
        const nextTarget = this.techTargets
            .map((item: any) => item.key)
            .filter((key: string) => nextTargets.includes(key))
            .join(',');
        this.ref.detectChanges();

        try {
            const { code, data } = await wiz.call('assign_department', { id: project.id, target: nextTarget });
            if (code === 200) {
                await this.loadDashboard();
                return;
            }
            await this.service.alert.show({
                title: '알림',
                message: data || '분배 대상을 변경할 수 없습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
        } catch (e: any) {
            await this.service.alert.show({
                title: '알림',
                message: e?.message || '분배 처리 중 오류가 발생했습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
        } finally {
            this.techAssigningProjectId = '';
            this.ref.detectChanges();
        }
    }

    public goToProject(project: any) {
        this.service.href('/project/detail/' + project.id);
    }

    public viewProject(id: string) {
        if (!id) return;
        this.service.href('/project/detail/' + id);
    }

    public viewChecklistResult(id: string) {
        if (!id) return;
        this.service.href('/checklist/result/' + id);
    }

    public goToProjectList() {
        this.service.href('/project/list');
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '-';
        return String(dateStr).split(' ')[0].split('T')[0];
    }

    public formatAmount(value: any): string {
        const numeric = Number(String(value || '').replace(/[^0-9]/g, ''));
        if (!numeric) return '-';
        return numeric.toLocaleString('ko-KR') + '원';
    }

    public formatNumber(value: any): string {
        const numeric = Number(value || 0);
        return numeric.toLocaleString('ko-KR');
    }

    public getWorkflowIconClass(status: string): string {
        if (status === 'complete') return 'bg-emerald-50 text-emerald-600';
        if (status === 'progress') return 'bg-blue-50 text-blue-600';
        return 'bg-slate-100 text-slate-400';
    }

    public getWorkflowBarClass(status: string): string {
        if (status === 'complete') return 'bg-emerald-500';
        if (status === 'progress') return 'bg-blue-500';
        return 'bg-slate-300';
    }

    public getDepartmentIconClass(key: string): string {
        if (key === '건축') return 'bg-blue-50 text-blue-600';
        if (key === '토목') return 'bg-orange-50 text-orange-600';
        return 'bg-teal-50 text-teal-600';
    }

    public getDepartmentBarClass(key: string): string {
        if (key === '건축') return 'bg-blue-500';
        if (key === '토목') return 'bg-orange-500';
        return 'bg-teal-500';
    }

    public formatParticipants(value: string): string {
        const names = String(value || '')
            .split(',')
            .map((name: string) => name.trim())
            .filter((name: string) => !!name);
        return names.length > 0 ? names.join(', ') : '미지정';
    }

    public getCategoryClass(category: string): string {
        if (category === '건축') return 'bg-blue-50 text-blue-600';
        if (category === '토목') return 'bg-orange-50 text-orange-600';
        return 'bg-slate-100 text-slate-600';
    }

    public getDistributionBadgeClass(project: any): string {
        if (project?.distribution_status === 'pending') return 'bg-rose-50 text-rose-600';
        return this.getCategoryClass(project?.target_department || project?.category);
    }

    public getCategoryLabel(category: string): string {
        const labels = String(category || '')
            .split(',')
            .map((item: string) => item.trim())
            .filter((item: string) => !!item)
            .map((item: string) => (item === '전체' || item === '기타(연구소)') ? '기타' : item);
        if (labels.length === 0) return '기타';
        return Array.from(new Set(labels)).join(', ');
    }

    public getStatusClass(status: string): string {
        if (status === 'scheduled') return 'bg-amber-50 text-amber-600';
        if (status === 'completed') return 'bg-slate-100 text-slate-500';
        return 'bg-emerald-50 text-emerald-600';
    }

    public getTypeClass(type: string): string {
        if (type?.includes('진단')) return 'badge-purple';
        if (type?.includes('정밀')) return 'badge-green';
        return 'badge-amber';
    }
}

export default PageMainComponent;